<template lang='html'>
  <div class='agency-interview'>
        <commissioner-interview-part v-for="part in parts"
                                     :parts-count="partsCount"
                                     :part="part"
                                     :key="part.id"
                                     :route-upload-video="routeUploadVideo"
                                     @itemDeleted="deleteItem"
        ></commissioner-interview-part>
        <div class="align-center">
            <button type="button" class='align-center big-purple-button' @click="addItem">Add more</button>
        </div>
  </div>
</template>

<script>
// Component for showing interview in admin dashboard
    
export default {
  props: ['questions', 'default', 'routeUploadVideo'],
  data() {
    return {
      parts: [],
      lastId: 0,
      partsCount: 0
    };
  },
  methods: {
    addItem() {
      this.lastId -= 1;
      this.parts.push({
        id: this.lastId
      });
      this.partsCount++;
    },
    deleteItem(removedPart) {
      this.parts = this.parts.filter((part) => {
        if (part.id !== removedPart.id) return true;
      });
      this.partsCount--;
    }
  },
  created() {
    if (this.questions) {
      this.questions.forEach((question) => {
        this.default.forEach((answer) => {
          if (answer.question_id === question.id) {
            question.answer = answer.answer;
            question.video_name = answer.video_name;
            question.images = question.images;
            this.parts.push(question);
          }
        });
      });
      this.partsCount = this.default.length == 0 ? 1 : this.default.length;
    } else {
      this.addItem();
    }
  }
};
</script>